
<template>
<!-- 危机逃脱中的邮件列表中的物品  Tank礼包[物品数据] 邮件模板[邮件物品] -->
  <div class="items" v-drag>
    <div  role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">物品</span>
          <span aria-hidden="true" class="modal-span" @click="close">&times;</span>
        </div>
        <div class="modal-body">
          <!-- Table -->
          <form class="form-inline">
            <button type="button" class="btn btn-default-determine" @click="sel_item">{{select_item}}</button>
          </form>
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th v-for="(item,index) in heade_data" :key="index">{{item}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list,index) in del_data" :key="index"> 
                <!-- <td v-for="(child_list,child_key,child_index) in list" :key="child_index"><input type="text" :value="child_list"></td>
                <td><input type="text" v-model="in_count" ></td> -->
                <td v-for="(child_list,child_key,child_index) in list" :key="child_index">{{child_list}}</td>
                <td><input type="text" v-model="in_count[list.item_id]"></td>
                <td><button class="btn_del" @click="btn_del(list)">{{del}}</button></td> 
              </tr>                   
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="cancel_selection">{{cancel}}</button>
          <button type="button" class="btn btn-default-determine" @click="determine">{{confirm}}</button>
        </div>
      </div>
    </div>
    <selectItems v-if="sel_ite" :language_pack="language_pack" :del_data="del_data" @selecte_btn="selecte_btn" @sle_btn="sle_btn"></selectItems>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import selectItems from "./select_items";
  import language_pack from "../store/language_pack.js"
  export default {
    name: 'items',
     data(){
    return {
      language_pack:language_pack,
      sel_ite:false,
      //头部复选框
      btn_check:false,
      //复选框的数组
      check_data:[],
      //获取的弹框数据
      list_data:null,
      //单选按钮
      list_radio:'',
      //头部数据
      show_data:null,
      //计数
      count:0,
      //头部数据
      // heade_data:['物品ID','物品名','数量','操作'],
      //移除数据项
      del_data:this.selecte_data,
      //编辑的数据
      in_count:{},
      //编辑时返回的数据的副本
      edit_data:this.rule_data
    }
    },
    components: {
      selectItems
    },
    computed:{
    heade_data(){
      return this.$attrs.language_pack[this.sel_language].heade_data
    },
    del(){
      return this.$attrs.language_pack[this.sel_language].del
    },
    select_item(){
      return this.$attrs.language_pack[this.sel_language].select_item
    },
    // head_title(){
    //   return '--'+this.$attrs.language_pack[this.sel_language].select_distribution_package+'--'
    // },
    confirm(){
      return this.$attrs.language_pack[this.sel_language].confirm
    },
    cancel(){
      return this.$attrs.language_pack[this.sel_language].cancel
    },
    ...mapState({
      sel_language:'sel_language'
    })
    },
    mounted () { 
      // alert(0)
      // console.log(this.selecte_data)
      // console.log(this.rule_data)
    // alert('editItems')
    // console.log(this.edit_data)
    // console.log(this.del_data)
    // if(this.selecte_data.length>0){
      if(this.rule_data!=undefined){
        // alert(0)
        this.editBoxData()
      // }else{
      //   this.rule_data_p.forEach((item,index)=>{
      //     this.del_data.forEach((ite,index)=>{
      //       if(ite.item_id==item.ID&&item.Count){
      //         // console.log(item)
      //        this.$set(this.in_count,ite.item_id,item.Count) 
      //       //  this.in_count[ite.item_id]=1;
      //       }
      //     })
      //     console.log(this.in_count)
      //   })
      }
      // else{
      //   this.edit_data=JSON.parse(this.edit_data);
      //   this.edit_data.forEach((ite,i)=>{
      //     if(this.edit_data.some((item,index)=>{return item.ID==this.del_data[index].item_id})){
      //       alert(0)
      //       this.in_count[ite.ID]=ite.Count;
      //     }
      //   })
        
      // }
    // }
    
    },
    props:{
    //编辑框中的数据
      rule_data:String,
    //选中的列表
      selecte_data:Array,
      // is_selecte_item:Boolean
      // rule_data_p:Array
    },
    methods: {
      sle_btn(){
        this.sel_ite=false;
      },
    selecte_btn(data){
      
      // console.log(data)
      this.del_data=data
      this.del_data.forEach((item,index)=>{
        // console.log(this.in_count[item.item_id])
        // console.log(item.item_id)
        if(this.in_count[item.item_id]==undefined){
          // alert(0)
          this.in_count[item.item_id]=1
        }
      })
      this.sel_ite=false;
    },
    //编辑时的数据项显示在此组件中
    editBoxData(){
      // alert(1)
      this.edit_data=JSON.parse(this.edit_data);
      // console.log(this.del_data)
      // this.del_data=[];
      this.edit_data.forEach((item,index)=>{
        // if(this.del_data.length>0&&item.ID!=this.del_data[index].item_id){
          this.del_data.push({item_id:item.ID,name:item.Name});
          this.in_count[item.ID]=item.Count;
        // }else{
          // this.del_data.push({item_id:item.ID,name:item.Name});
          // this.in_count[item.ID]=item.Count;
        // }
        
        
      })  
      // console.log(this.del_data)
      

      
    },
    //删除数据列表
    btn_del(list){
      // console.log(list,this.del_data)
      // this.del_data.push()
      this.del_data=this.del_data.filter((item,index)=>{
        return item!=list
      })
      // this.del_data=this.edit_data.filter((item,index)=>{
      //   return item.ID!=list
      // })
    },
    //关闭弹框
    close(){
      this.$emit("close_edit")
    },
    //取消按钮
    cancel_selection(){
      this.$emit("close_edit")
    },
    //确认按钮
    determine(){
      var data=[];
      if(this.del_data.length){
        this.del_data.forEach((item,index)=>{
          data.push({ID:item.item_id,Name:item.name,Count:this.in_count[item.item_id]})
        })
        data=JSON.stringify(data);
      }else{
        data=''
      }   
      // console.log(data)
      this.$emit("sbmit_data",data)
    },
    // 选择物品组件
    sel_item(){
      // console.log(this.edit_data)
      // console.log(this.rule_data_p)
      this.sel_ite=true
      // if(this.rule_data!=''){
        // this.$emit("sel_goods",this.del_data);
      // }else{
      //   this.$emit("sel_goods",this.rule_data_p);
      // }
      
    }
    },
    directives: {
    drag: {
      inserted(el) {
        let drag_Box = el; //获取当前元素
        let dragBox = document.getElementsByClassName('modal-header')[0];
        dragBox.onmousedown = e => {
          //算出鼠标相对元素的位置
          let disX = e.clientX - drag_Box.offsetLeft;
          let disY = e.clientY - drag_Box.offsetTop;
          document.onmousemove = e => {
            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;
            //移动当前元素
            drag_Box.style.left = left + "px";
            drag_Box.style.top = top + "px";
          };
          document.onmouseup = e => {
            //鼠标弹起来的时候不再移动
            document.onmousemove = null;
            //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
            document.onmouseup = null;
          };
        };
      }
    }
    }
  }
</script>
<style scoped>
  input{
    outline: none;
  }
  .btn_del{
    background-color: #d43f3a;
    color: #fff;
    border: none;
    outline: none;
  }
  .text-nowrap{
      margin-top: 10px;
  }
  .modal-body{
    max-height: 500px;
    overflow: auto;
  }
  .table>tbody>tr>td {
        text-align: center;
    }
  .table>thead>tr>th {
        text-align: center;
    }
	.items{
    position: fixed;
    top: 30%;
    left: 20%;
    min-width: 846px;
    z-index:999
    /* transform: translate(-50%, -50%); */
  }
 .modal-header{
		background:#ebecf0;
		height:40px;
    cursor: move;
	}
 .modal-span{
		font-size:20px;
		margin-top:-14px;
		cursor:pointer
	}
	.modal-title{
		line-height:1px
	}
  .btn-default-close{
    color:#007bff;
		font-size:12px;
		border:1px solid #808080;
		padding:4px;
		/* margin-right: 90%; */
  }
  .modal-footer{
    justify-content: space-between;
  }
  .btn-default-determine{
    color:#007bff;
		font-size:12px;
		border: 1px solid rgb(128, 128, 128);
		padding: 4px;
  }
  td{
    font-size: 12px;
  }
</style>